@if (fragmentOnRouting() === 'product-list-top') {
<a id="product-list-top" title="top"></a>
} @if (productListingView$ | async; as listing) { @if (isEndlessScrolling) {
<div
  infiniteScroll
  (scrolled)="loadMoreProducts('down')"
  (scrolledUp)="loadMoreProducts('up')"
  [alwaysCallback]="true"
  [immediateCheck]="true"
>
  <ish-product-list-toolbar
    [itemCount]="listing.itemCount"
    [sortableAttributes]="listing.sortableAttributes"
    [viewType]="viewType$ | async"
    [sortBy]="sortBy$ | async"
    [fragmentOnRouting]="fragmentOnRouting()"
    (productSortSelected)="onProductSortSelected($event)"
  />
  <ish-product-list [products]="listing.products()" [categoryId]="categoryId()" [viewType]="viewType$ | async" />
  @if (!isEndlessScrolling) {
  <div class="row justify-content-center">
    @if (!listing.allPagesAvailable()) {
    <ish-product-list-paging
      [currentPage]="listing.lastPage"
      [pageIndices]="listing.pageIndices()"
      [fragmentOnRouting]="fragmentOnRouting()"
    />
    }
  </div>
  }
</div>
} @if (isPaging) {
<div>
  @if (currentPage$ | async; as currentPage) {
  <ng-template #pagingToolbar>
    <ish-product-list-toolbar
      [itemCount]="listing.itemCount"
      [sortableAttributes]="listing.sortableAttributes"
      [viewType]="viewType$ | async"
      [sortBy]="sortBy$ | async"
      [currentPage]="currentPage"
      [pageIndices]="listing.pageIndices(currentPage)"
      [fragmentOnRouting]="fragmentOnRouting()"
      [isPaging]="true"
    />
  </ng-template>
  <ng-container *ngTemplateOutlet="pagingToolbar" />
  <ish-product-list
    [products]="listing.productsOfPage(currentPage)"
    [categoryId]="categoryId()"
    [viewType]="viewType$ | async"
  />
  @if (listingLoading$ | async) {
  <ish-loading [standalone]="true" />
  }
  <ng-container *ngTemplateOutlet="pagingToolbar" />
  }
</div>
} }
